import React from 'react';
import { bool, number, func } from 'prop-types';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import Icon from '../../StoraEnsoComponents/Icon';

const Wrapper = styled.div`
  .paginationWrapper {
    display: inline-flex;
    align-items: center;

    li {
      padding: 0.5rem;

      &.active {
        background-color: #c3e2f5;
      }
    }

    li a {
      color: #202020;
      display: flex;
      align-items: center;
      font-weight: bold;
      text-decoration: none;
      cursor: pointer;

      &:hover:not(.disabled) {
        color: #696969;
      }

      &.disabled {
        cursor: auto;
      }
    }
  }
`;

function Pagination({
  loading,
  pageCount,
  onPageChange,
}) {
  return (
    <Wrapper>
      <ReactPaginate
        className="paginationWrapper"
        activeClassName="active"
        breakLabel="..."
        nextLabel={<Icon size="lg">chevron_right</Icon>}
        onPageChange={({selected}) => !loading && onPageChange(selected)}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={<Icon size="lg">chevron_left</Icon>}
        disabledClassName="disabled"
        disabledLinkClassName="disabled"
        renderOnZeroPageCount={null}
      />
    </Wrapper>
  );
}

Pagination.propTypes = {
  loading: bool.isRequired,
  pageCount: number.isRequired,
  onPageChange: func.isRequired,
};
export default Pagination;
